export const COMPANY_INFO_KEYS = {
  TAX_CODE: 'taxCode',
  ENTERPRISE_STATUS: 'activeStatusId',
  REGISTERED_ADDRESS: 'address',
  INDUSTRY: 'vsicName',
  LEGAL_FORM: 'legalFormName',
  YEARS_OF_OPERATION: 'age',
  YEAR_OF_OPERATION: 'yearOfOperation',
  DATE_OF_REGISTRATION: 'registerDate',
  DATE_OF_INCORPORATION: 'dateOfIncorporation',
  REGISTRATION_NUMBER: 'registrationNumber',
  VAT_NUMBER: 'vat',
  LEGAL_FORM_INTER: 'legalForm',
}

export const COMPANY_INFO_OPTIONS = [
  {
    name: 'domesticSearchPreview.TAX_CODE',
    value: COMPANY_INFO_KEYS.TAX_CODE,
    nameInternational: 'domesticSearchPreview.REGISTRATION_NUMBER',
    valueInternational: COMPANY_INFO_KEYS.REGISTRATION_NUMBER,
  },
  {
    name: 'domesticSearchPreview.ENTERPRISE_STATUS',
    value: COMPANY_INFO_KEYS.ENTERPRISE_STATUS,
  },
  {
    name: 'domesticSearchPreview.REGISTERED_ADDRESS',
    value: COMPANY_INFO_KEYS.REGISTERED_ADDRESS,
  },
  {
    name: 'domesticSearchPreview.INDUSTRY',
    value: COMPANY_INFO_KEYS.INDUSTRY,
    nameInternational: 'domesticSearchPreview.VAT_NUMBER',
    valueInternational: COMPANY_INFO_KEYS.VAT_NUMBER,
  },
  {
    name: 'domesticSearchPreview.LEGAL_FORM',
    value: COMPANY_INFO_KEYS.LEGAL_FORM,
    nameInternational: 'domesticSearchPreview.LEGAL_FORM',
    valueInternational: COMPANY_INFO_KEYS.LEGAL_FORM_INTER,
  },
  {
    name: '',
    value: '',
  },
  {
    name: 'domesticSearchPreview.YEARS_OF_OPERATION',
    value: COMPANY_INFO_KEYS.YEARS_OF_OPERATION,
    nameInternational: 'domesticSearchPreview.YEARS_OF_OPERATION',
    valueInternational: COMPANY_INFO_KEYS.YEAR_OF_OPERATION,
  },
  {
    name: 'domesticSearchPreview.DATE_OF_REGISTRATION',
    value: COMPANY_INFO_KEYS.DATE_OF_REGISTRATION,
    nameInternational: 'domesticSearchPreview.DATE_OF_REGISTRATION',
    valueInternational: COMPANY_INFO_KEYS.DATE_OF_INCORPORATION,
  },
]

export const INTERNATIONAL_INDEX = [0, 3, 4, 6, 7]

export const TREE_AGE_OPTIONS = [
  {
    label: '0 - 2',
    minAge: 0,
    maxAge: 2,
    icon: 'icon-tree-age-0-2',
    style: {
      fontSize: 20,
    },
  },
  {
    label: '3 - 5',
    minAge: 3,
    maxAge: 5,
    icon: 'icon-tree-age-3-5',
    style: {
      fontSize: 32,
    },
  },
  {
    label: '6 - 20',
    minAge: 6,
    maxAge: 20,
    icon: 'icon-tree-age-6-20',
    style: {
      fontSize: 40,
    },
  },
  {
    label: '21 - 50',
    minAge: 21,
    maxAge: 50,
    icon: 'icon-tree-age-21-50',
    style: {
      fontSize: 60,
    },
  },
  {
    label: '51+',
    minAge: 51,
    maxAge: 51,
    icon: 'icon-tree-age-51-plus',
    style: {
      fontSize: 80,
    },
  },
  {
    label: 'domesticSearchPreview.YEARS',
    minAge: -1,
    maxAge: -1,
    icon: '',
    style: {},
  },
]
